import type { BoardModel } from '../../models/board/BoardModel';
import type { BoardView } from '../../views/board/BoardView';
import { AdBlockerModel } from '../../models/blockers/AdBlockerModel';

export interface AdBlockerConfig {
  model: BoardModel;
  view: BoardView;
  triggerAd: (actionId: string) => Promise<boolean>;
  isInBoosterMode: () => boolean;
}

export class AdBlockerController {
  constructor(config: AdBlockerConfig) {
    this.init(config);
  }

  private init({ model, view, triggerAd, isInBoosterMode }: AdBlockerConfig): void {
    view.onStackTapped.connect(async (stack) => {
      if (isInBoosterMode()) return;

      if (!(stack.blocker instanceof AdBlockerModel)) return;

      const success = await triggerAd('ad-blocker');

      if (!success) return;

      model.removeBlocker(stack, stack.blocker);
    });
  }
}
